import { render, staticRenderFns } from "./x-operation-select.vue?vue&type=template&id=36a157ad&"
import script from "./x-operation-select.vue?vue&type=script&lang=js&"
export * from "./x-operation-select.vue?vue&type=script&lang=js&"
import style0 from "./x-operation-select.vue?vue&type=style&index=0&id=36a157ad&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports